export enum ModalsEnum {
    freeUserFreeDownloadUpsell = 'freeUserFreeDownloadUpsell',
    creditsWarning = 'creditsWarning',
    removeSamplesFromCollection = 'removeSamplesFromCollection',
    createCollectionModal = 'createCollectionModal',
    editCollectionModal = 'editCollectionModal',
    deleteCollectionModal = 'deleteCollectionModal',
    poorStandingOrSuspended = 'poorStandingOrSuspended',
    keyboardCheatSheet = 'keyboardCheatSheet',
    sweetenerUpsellModal = 'sweetenerUpsellModal',
    planPaused = 'planPaused',
    activateTrialSubscription = 'activateTrialSubscription',
    trialUpsellModal = 'trialUpsellModal',
    advancedFiltersModal = 'advancedFiltersModal',
}
